var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            [
              _c("label", { staticStyle: { color: "#1890ff" } }, [
                _vm._v("XML：")
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "40%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.toJson }
                },
                [_vm._v("确定")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { "flex-grow": "1" } },
            [
              _c("origin-el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.xmlStr,
                  callback: function($$v) {
                    _vm.xmlStr = $$v
                  },
                  expression: "xmlStr"
                }
              })
            ],
            1
          ),
          _c("el-form-item", [
            _c("label", { staticStyle: { color: "#1890ff" } }, [
              _vm._v("JSON：")
            ])
          ]),
          _c(
            "el-form-item",
            { staticStyle: { "flex-grow": "1" } },
            [
              _c("origin-el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.jsonStr,
                  callback: function($$v) {
                    _vm.jsonStr = $$v
                  },
                  expression: "jsonStr"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }